// extracted by mini-css-extract-plugin
module.exports = {"view":"_2529","toast":"_16767","pre":"_5567","qrcode":"_2675"};